'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getWidgetUiState = exports.getWidgetUiState = function getWidgetUiState(state) {
  return state.widgetUi;
};


//////////////////
// WEBPACK FOOTER
// ./js/selectors/getWidgetUiState.js
// module id = 270
// module chunks = 2 3